import { createAsyncThunk } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'
import { Doctor } from 'types'
import { getCookies } from 'utils/cookieHelpers'
import { filterQueryParams } from 'utils/filterQueryParams'
import { getLivePreviewToken } from 'utils/livePreview'

interface GetDoctorsParams {
  specialty?: string
  patientId?: number
  all?: boolean
  partner_name?: string
}

export const getDoctors = createAsyncThunk(
  'get-doctors',
  async (params: GetDoctorsParams | undefined = {}, { rejectWithValue, getState }) => {
    try {
      const profile = (getState() as { auth?: { profile?: { partnerName?: string | null } } }).auth?.profile
      const partnerFromCookies =
        typeof window === 'undefined'
          ? undefined
          : getCookies('isMedleveAddress')?.isValid
          ? 'medleve'
          : getCookies('isIshaAddress')?.isValid
          ? 'isha'
          : undefined

      // Pre-launch testing: when the visitor arrived via ?live=<token>, forward
      // the token so the backend injects the "Atendimento ao vivo" option.
      const livePreview = getLivePreviewToken()

      const { data } = await railsApiService.apiInstance.get<Doctor[]>('/api/v1/doctors', {
        params: filterQueryParams({
          ...params,
          partner_name: params.partner_name || partnerFromCookies || profile?.partnerName,
          live_preview: livePreview || undefined
        })
      })

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
